import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './AwardBadgeButton';
import { beginDeviationAwardBadgeFlow } from '../../../coreBadge/redux/actionCreators';
import { getLimitedBadgesPromo } from '../../../publicSession/selectors';

type StateProps = Pick<Props, 'limitedBadgesPromo'>;
type DispatchProps = Pick<Props, 'onAwardClick'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => ({
  limitedBadgesPromo: getLimitedBadgesPromo(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onAwardClick: beginDeviationAwardBadgeFlow,
};

export default connect(mapStateToProps, mapDispatchToProps);
